import styled from "styled-components";

export const EasyNavigationCard = styled.button`
  border: none;
  background: linear-gradient(135deg, var(--primary) 0%, var(--primary-light) 100%);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--lightest);
  padding: 40px 20px;
  width: 100%;
  height: 100%;
  min-height: 160px;
  box-shadow: 0 4px 12px rgba(46, 49, 146, 0.15);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, var(--primary-light) 0%, var(--primary) 100%);
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  > img,
  > svg {
    position: relative;
    z-index: 1;
    color: var(--lightest);
    fill: var(--lightest);
    filter: brightness(0) invert(1);
    transition: transform 0.3s ease;
  }

  > span {
    font-size: 1rem;
    font-weight: 600;
    margin-top: 16px;
    position: relative;
    z-index: 1;
    text-align: center;
  }

  &:hover {
    cursor: pointer;
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(46, 49, 146, 0.25);

    &::before {
      opacity: 1;
    }

    > img,
    > svg {
      transform: scale(1.1);
      color: var(--lightest);
      fill: var(--lightest);
    }
  }

  &:active {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(46, 49, 146, 0.2);
  }

  @media (max-width: 768px) {
    padding: 32px 16px;
    min-height: 140px;
  }
`;

export const EasyNavigationContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 16px;
  }
`;

export const EasyNavigationGroup = styled.div`
  width: 100%;

  & + & {
    margin-top: 32px;
    padding-top: 28px;
    border-top: 1px solid var(--gray-light);
  }
`;

export const EasyNavigationGroupLabel = styled.h3`
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--neutral-light);
  margin: 0 0 16px 0;
`;